import { RequestService } from 'services/request.service'
import {
  PinnedCardsRequestType,
  PinnedCardsListResponseType,
  PinnedCardsRecordType,
} from './apiTypes/pinnedCards.types'
import { CardType } from 'types/deck'
import { responseToCard } from 'utils/ResponseToResults'

export class PinService extends RequestService {
  create = async (records: PinnedCardsRequestType[] | PinnedCardsRequestType): Promise<PinnedCardsRecordType> => {
    if (!Array.isArray(records)) records = [records]

    const pinRecordsToCreate = records.map(record => ({
      cardId: record.card,
      notes: record.notes,
      modifier: record.modifier,
      quantity: record.quantity,
    }))

    const recordCard = await super.post(`/api/users/pins/`, {
      cards: pinRecordsToCreate,
    })

    return { ...recordCard, card: responseToCard(recordCard.card, recordCard, false) }
  }

  add = (cards: CardType | CardType[]): Promise<PinnedCardsRecordType> => {
    const cardsToAdd = Array.isArray(cards) ? cards : [cards]

    const cardsToAddToPin = cardsToAdd
      .filter(card => !!card.cardId) // Remove any custom cards from group pins
      .map(card => ({
        card: card.cardId,
        modifier: card.modifier,
        notes: '',
        quantity: 1,
      }))

    // @ts-ignore - the filter above ensures that there are no null cards that are attempting to be pinned
    return this.create(cardsToAddToPin)
  }

  update = (record: PinnedCardsRecordType): Promise<PinnedCardsRecordType> => {
    return super.patch(`/api/users/pins/${record.id}/`, {
      card: record.card.cardId,
      quantity: record.quantity,
      notes: record.notes,
      modifier: record.card.modifier,
    })
  }

  remove = (record: PinnedCardsRecordType): Promise<string> => {
    return super.delete(`/api/users/pins/${record.id}/`, undefined, true).then(() => `${record.id}`)
  }

  removeAll = () => {
    return super.delete(`/api/users/pins/deleteAll/`, undefined, true)
  }

  list = async (): Promise<PinnedCardsRecordType[]> => {
    const { cards } = await super.get<PinnedCardsListResponseType>(`/api/users/pins/`)

    return cards.reduce((acc: PinnedCardsRecordType[], recordCard: any) => {
      const card = recordCard.card
      const serializedCard = responseToCard(card, recordCard, false)

      acc.push({ ...recordCard, card: serializedCard })
      return acc
    }, new Array<PinnedCardsRecordType>())
  }
}

const pinService = new PinService()

export default pinService
